// -----------------------------------------------------------------
// I n i t i a l   S t a t e
// -----------------------------------------------------------------
import { BREADCRUMBS_TYPES, BreadcrumbsAction } from "./types";
import { SIGN_OUT_TYPES } from "../auth/signOut/types";
import { Breadcrumb, Page } from "../../data/interfaces";
import { ROUTES, ROUTES_KEYS } from "../../routing/routes";
import { PAGES } from "../../routing/pages";
import * as H from "history";
import { SIGN_IN_TYPES } from "../auth/signIn/types";

const INITIAL_ROUTE = {
  location: {
    pathname: ROUTES.HOME,
    search: "",
    state: null,
    hash: "",
    key: ROUTES_KEYS.HOME,
  },
  depth: 1,
  label: PAGES.find((p: Page) => p.key === ROUTES_KEYS.HOME)?.label || "",
};
const INITIAL_STATE = {
  history: [INITIAL_ROUTE],
};

// -----------------------------------------------------------------
// S t a t e   I n t e r f a c e
// -----------------------------------------------------------------
export interface BreadcrumbsState {
  history: Breadcrumb[];
}

// -----------------------------------------------------------------
// A c t i o n   s w i t c h e r
// -----------------------------------------------------------------

const findPageByKey = (data: any[], val: any) => {
  function iter(a: any) {
    if (a.path === val) {
      result = a;
      return true;
    }
    return Array.isArray(a.nested) && a.nested.some(iter);
  }

  let result;
  data.some(iter);
  return result;
};

const pushBreadcrumb = (history: Breadcrumb[], payload: H.Location, depth: number) => {
  const NEW_BREADCRUMB: Breadcrumb = { location: payload, depth: depth, label: "" };

  if (!history.some((b: Breadcrumb) => b.location.pathname === payload.pathname)) {
    // Assign the Breadcrumb label by searching through the pages according to the value of the path property
    for (const key in ROUTES) {
      if (ROUTES.hasOwnProperty(key)) {
        // @ts-ignore
        const REGEX = "^" + ROUTES[key].replace(/\//g, "\\/").replace(/:[^\\/]+/g, "[^\\/]+") + "$";
        if (!!payload.pathname.match(REGEX)) {
          // @ts-ignore
          const PAGE_BY_KEY: Page = findPageByKey(PAGES, ROUTES[key]);
          if (!!PAGE_BY_KEY) {
            NEW_BREADCRUMB.label = PAGE_BY_KEY.label;
          }
        }
      }
    }
    history.push(NEW_BREADCRUMB);
  }
};

export default (state: BreadcrumbsState = INITIAL_STATE, action: BreadcrumbsAction): BreadcrumbsState => {
  switch (action.type) {
    case BREADCRUMBS_TYPES.COMPLETED:
      if (state.history.length > 0) {
        const LOCATION_INDEX_IN_HISTORY = state.history.findIndex((l: Breadcrumb) => l && l.location.pathname === action.payload.pathname);
        const DEPTH = (action.payload.pathname.match(/\//g) || []).length;
        // If the page level is greater than or equal to the previous one, replace the last one with the current one
        if (DEPTH < state.history[state.history.length - 1].depth || (DEPTH === 1 && state.history[state.history.length - 1].depth === 1)) {
          state.history.length = 1;
          pushBreadcrumb(state.history, action.payload, DEPTH);
        } else {
          // If there is already a location in the history, remove all those after the record
          if (state.history.some((b: Breadcrumb) => b && b.location.pathname === action.payload.pathname)) {
            // If the element found is not the last of the history, remove subsequent locations
            if (LOCATION_INDEX_IN_HISTORY !== state.history.length - 1) {
              state.history.length = LOCATION_INDEX_IN_HISTORY + 1;
            }
          } else {
            // Otherwise add the location to the history
            pushBreadcrumb(state.history, action.payload, DEPTH);
          }
        }
      }
      return state;
    case BREADCRUMBS_TYPES.RESET:
    case SIGN_OUT_TYPES.COMPLETED:
    case SIGN_IN_TYPES.COMPLETED:
      return { ...state, history: [INITIAL_ROUTE] };
    default:
      return state;
  }
};
